import { render, staticRenderFns } from "./DtsTimeStreamax.vue?vue&type=template&id=0e1fe550&scoped=true&"
import script from "./DtsTimeStreamax.vue?vue&type=script&lang=ts&"
export * from "./DtsTimeStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./DtsTimeStreamax.vue?vue&type=style&index=0&id=0e1fe550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1fe550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0e1fe550', component.options)
    } else {
      api.reload('0e1fe550', component.options)
    }
    module.hot.accept("./DtsTimeStreamax.vue?vue&type=template&id=0e1fe550&scoped=true&", function () {
      api.rerender('0e1fe550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/TimeSetup/DtsTimeStreamax.vue"
export default component.exports